import { DialogContent } from '@nexelem/deprecated-theme';
import { cn } from '@nexelem/utils';
import { ComponentProps } from 'react';

export const ModalContent = ({ className, ...props }: ComponentProps<typeof DialogContent>) => (
  <DialogContent className={cn('px-6 py-4', className)} {...props} />
);
